let map = {
	'lumand.com': 'lumand.com'
  , 'www.lumand.com': 'lumand.com'
  , 'test.lumand.com': 'test.lumand.com'
}
let domain  = map[window.location.hostname] || 'dev.lumand.com'
export default domain



// WEBPACK FOOTER //
// ./src/utils/domain.js